import {Component, Inject, OnInit} from '@angular/core';
import {ActionsFilters} from "../../actions/actions-filter/actions-filter.interface";
import {UtilsService} from "../../shared/utils.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  NetworkedUsersSelectorComponent
} from "../../shared/networked-users-selector/networked-users-selector.component";

@Component({
  selector: 'app-assets-view-corrective-actions-filter',
  templateUrl: './assets-view-corrective-actions-filter.component.html',
  styleUrls: ['./assets-view-corrective-actions-filter.component.scss']
})
export class AssetsViewCorrectiveActionsFilterComponent implements OnInit {

  filters: ActionsFilters = {
    assigned_users: [],
    priority: '',
    status: '0',
    type: '',
    date_range: []
  } as ActionsFilters;

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetsViewCorrectiveActionsFilterComponent>
  ) { }

  ngOnInit() {
    // Set default values if not provided.
    this.filters.assigned_users = this.data['assigned_users'] || [];
    this.filters.priority = this.data['priority'] || '';
    this.filters.status = (this.data['completed'] || 0).toString();
    this.filters.type = this.data['type'] || '';
    this.filters.date_range = this.data['date_range'] || '';
  }

  /**
   * Select networked users and update the user IDs filters.
   *
   * @return {void}
   */
  onSelectUsers(): void {
    this.utils.showComponentDialog(NetworkedUsersSelectorComponent, {
        selected: this.filters.assigned_users,
        multiple: true,
        visitors_from_all_sites: true
      }, {
        width: '1200px'
      }, (results: any): void => {
        if ( typeof results != 'undefined' ) {
          this.filters.assigned_users = results;
        }
      }
    );
  }

  /**
   * Sets the output date range based on the provided event value.
   *
   * @param {any} event - The event value to set the date range.
   * @return {void} - No return value.
   */
  getOutputDateRange(event: any): void {
    this.filters.date_range = event;
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.assigned_users = [];
    this.filters.priority = '';
    this.filters.status = '0';
    this.filters.type = '';
    this.filters.date_range = [];

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    let response: any;

    response = {
      assigned_users: this.filters.assigned_users,
      priority: this.filters.priority,
      completed: Number(this.filters.status),
      type: this.filters.type,
      date_range: this.filters.date_range
    }

    this.dialogRef.close(response);
  }

  /**
   * Closes the dialog.
   *
   * @return {void}
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Clears the date range for this filter.
   *
   * @returns {void}
   */
  onClearDateRange(): void {
    this.filters.date_range = [];
  }
}
